import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
// import { Header } from '../../components'
import Stepper from '../../components/stepper/Stepper'
import StepsContext from '../../contexts/StepsContext'
import questions from '../../utils/questions.json'
import SidebarQuestions from './SidebarQuestions'
import IStep from '../../interfaces/Step'
// import SidebarQuestions from './SidebarQuestions'

export default function Questions(): React.ReactElement {
	// const [questions, setQuestions] = useState<IStep[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const { steps, setSteps } = useContext(StepsContext)
	function getStepsQuestions(): void {
		// setIsError(false)
		try {
			setIsLoading(true)
			const json = questions as Array<IStep>
			setSteps(json)
			setIsLoading(false)
		} catch (e) {
			// setIsError(true)
		}
	}

	useEffect(() => {
		getStepsQuestions()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<>
			<SidebarQuestions />
			<div className="background-question">
				<div className="container">
					<Helmet>
						<title> Quizz </title>
						<meta name="description" content="Quizz" />
					</Helmet>
					{steps.length && !isLoading && <Stepper />}
				</div>
			</div>
		</>
	)
}
